import { render } from "./lang-switcher.vue?vue&type=template&id=75aa7006"
import script from "./lang-switcher.vue?vue&type=script&lang=js"
export * from "./lang-switcher.vue?vue&type=script&lang=js"

import exportComponent from "/home/eymekkjd/staging.infos-projet.app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__